import * as React from "react";
import {Button, Grid, Modal} from "semantic-ui-react";

export interface ContractContextMenuProps {
    isOpen: boolean
    onClose: (modalToOpen: "other implementations" | "other implementations matching value" | null) => void
    x: number,
    y: number,
    values: any[],
    fieldName: any
}

export function ContractContextMenu(props: React.PropsWithChildren<ContractContextMenuProps>) {

    const handleClose = () => {
        props.onClose(null)
    }

    const calculateModalDirection = () => {
        if(props.y > window.innerHeight / 2) {
            return {bottom: window.innerHeight - props.y}
        } else {
            return {top: props.y}
        }
    }

    function customContextMenuOptions() {
        return [
            "other implementations",
            "other implementations matching value"
        ]
    }

    function onClickAction(option) {
        switch (option) {
            case "other implementations": {
                props.onClose("other implementations")
                break;
            }
            case "other implementations matching value": {
                props.onClose("other implementations matching value")
                break;
            }
            default: {
                break;
            }
        }
        handleClose()
    }

    let styles = {
        left: props.x,
        contextMenuModalDimmer: {
            backgroundColor: "transparent",
            '&:ui.dimmer': {
                position: 'static',
            }
        }
    }

    styles = {...styles, ...calculateModalDirection()}

    return (
        <Modal
            className={"contextMenuModal"}
            open={props.isOpen}
            onClose={handleClose}
            style={styles}
            size='mini'
            dimmer={{className: 'contextMenuModalDimmer'}}
        >
            <Modal.Content>
                <Grid padded="horizontally" stackable columns='equal' centered>
                    {customContextMenuOptions().map((option) => {
                        return <Grid.Row>
                            <Button
                                style={{width: "100%"}}
                                onClick={() => onClickAction(option) }
                            >
                                {option}
                            </Button>
                        </Grid.Row>
                    })}
                </Grid>
            </Modal.Content>
        </Modal>
    )
}

